module.exports = __webpack_public_path__ + "static/media/visa.5d39279f.svg";